// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video.vertical-fit {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.video.vertical-fit .video-container {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: fit-content;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video.vertical-fit .video-container .video-image {
  width: 100%;
  height: auto;
}
.video.horizontal-fit {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.video.horizontal-fit .video-container {
  position: absolute;
  z-index: 1;
  width: fit-content;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video.horizontal-fit .video-container .video-image {
  width: auto;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Video.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EAGA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;AAFR;AAOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AALJ;AAOI;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAGA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;AAPR","sourcesContent":[".video {\r\n  &.vertical-fit{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n\r\n    .video-container{\r\n      position: absolute;\r\n      z-index: 1;\r\n      width: 100%;\r\n      height: fit-content;\r\n      max-height: 100%;\r\n\r\n      // 上下中央揃えクリップ\r\n      overflow: hidden;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      .video-image{\r\n        width: 100%;\r\n        height: auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.horizontal-fit{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n  \r\n    .video-container{\r\n      position: absolute;\r\n      z-index: 1;\r\n      width: fit-content;\r\n      height: 100%;\r\n      max-width: 100%;\r\n  \r\n      // 上下中央揃えクリップ\r\n      overflow: hidden;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n  \r\n      .video-image{\r\n        width: auto;\r\n        height: 100%;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
